<template>
  <div id="container">
    <div id="content">
      <div id="title">
        <svg id="pressor-button" viewBox="0 0 126 126">
          <g fill="none" fill-rule="evenodd" transform="translate(0 -1)">
            <path
              fill="#FFC000"
              stroke="#504F4F"
              d="M63.4479168,2.02808151 C63.3993607,1.93019862 63.3200778,1.85091576 63.2221949,1.80235968 C62.9748173,1.67964481 62.6747981,1.78070392 62.5520832,2.02808151 L1.1644251,125.777805 C1.13016722,125.846865 1.11234185,125.92291 1.11234185,126 C1.11234185,126.276142 1.33619948,126.5 1.61234185,126.5 L124.387658,126.5 C124.464748,126.5 124.540794,126.482175 124.609853,126.447917 C124.857231,126.325202 124.95829,126.025183 124.835575,125.777805 L63.4479168,2.02808151 Z"
            />
            <g fill="#504F4F" transform="translate(58 48)">
              <rect width="11" height="44" />
              <rect width="11" height="11" y="50" />
            </g>
          </g>
        </svg>
        <svg id="title-svg" viewBox="0 0 100 100">
          <text
            x="0"
            y="48"
            font-family="SegoeUI, Segoe UI"
            font-size="7"
            font-weight="normal"
            fill="#00413B"
          >
            <tspan>Stop Patient Blood Pressure</tspan>
            <tspan x="0" dy="1.2em">Monitoring Session</tspan>
          </text>
        </svg>
      </div>
      <div id="buttons">
        <svg
          id="buttons-desc"
          viewBox="0 0 20 10"
          preserveAspectRatio="xMinYMin meet"
        >
          <text
            font-family="SegoeUI, Segoe UI"
            font-size="2.0"
            font-weight="normal"
            fill="#00413B"
          >
            <tspan x="0" y="2">
              This will stop the current blood pressure monitoring session and
            </tspan>
            <tspan x="0" dy="1.2em">
              return to the launchscreen. The session cannot be resumed once
            </tspan>
            <tspan x="0" dy="1.2em">stopped.</tspan>
          </text>
        </svg>
        <div id="ok-cancel">
          <button id="stop" class="button" @click="clickOK">
            Stop Session
          </button>
          <button id="cancel" class="button" @click="clickClose">Cancel</button>
        </div>
      </div>
    </div>
    <svg id="close" viewBox="0 0 40 39" @click="clickClose">
      <g stroke="none" stroke-width="1" fill="none" fill-rule="evenodd">
        <g>
          <rect id="bg" fill="#00413B" x="0" y="0" width="100%" height="100%" />
          <polygon
            id="Path"
            fill="#FFFFFF"
            points="9 2 20.013 15.845 31.0275928 2 36.0275928 2 22.509 18.982 36.0275928 35.975305 31.0458031 35.975305 20.013 22.116 8.98178971 35.975305 4 35.975305 17.518 18.982 4 2"
          />
        </g>
      </g>
    </svg>
  </div>
</template>

<script>
export default {
  name: 'ConfirmExit',
  methods: {
    clickClose() {
      this.$emit('close-dialog')
    },
    clickOK() {
      this.$emit('end-session')
    }
  }
}
</script>

<style scoped>
text {
  font-family: 'Segoe UI', Tahoma, Geneva, Verdana, sans-serif;
}
#container {
  position: relative;
  background-color: white;
  border: 2px solid #00413b;
}

#close {
  position: absolute;
  width: 8%;
  height: 8%;
  top: 0;
  right: 0;
  background-color: #00413b;
}

#content {
  position: absolute;
  width: 100%;
  height: 100%;
  display: flex;
  flex-direction: column;
}

#title {
  flex: 40%;
  max-height: 40%;
  display: flex;
  flex-direction: row;
  align-items: center;
}

#pressor-button {
  box-sizing: border-box;
  padding: 4%;
  width: 25%;
  margin-left: 2%;
}

#title-svg {
  width: 70%;
  margin-left: 0;
}

#buttons {
  flex: 60%;
  max-height: 60%;
  display: flex;
  flex-direction: column;
}

#buttons-desc {
  width: 100%;
  height: 60%;
  box-sizing: border-box;
  padding: 1% 4% 1% 4%;
}
#ok-cancel {
  height: 40%;
  position: relative;
  padding: 1%;
}
.button {
  border: none;
  background-color: #c4c4c4;
  font-size: 1.7vw;
}
#cancel {
  margin: 0 auto;
  height: 60%;
  width: 23%;
}
#stop {
  position: absolute;
  right: 2%;
  bottom: 13%;
  width: 25%;
}
</style>
